<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <br>
            <v-card-text>Are you sure you want the remove claim {{ claim }} and all of it's history?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small v-on:click="rmHosm">Yes</v-btn>
                <v-btn color="success" small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default 
{
    props: {
        huov_encrid: String
    },
    data() {
        return {
            dialog: false,
            hosm_encrid: '',
            claim: '',
        }
    },
    methods: {
        open(hosm_encrid, claim) {
            this.dialog = true;
            this.hosm_encrid = hosm_encrid;
            this.claim = claim;
        },
        rmHosm() {
            this.$axios
                .post("ares/json/ares/huov/hosm/rmHosm.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHosm"
                    },
                    rmHosm: {
                        hosm_encrid: this.hosm_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$emit('updateField', {field: 'showDetails', value: false});
                        this.$emit('updateData', 'refresh');
                        this.dialog = false;
                    }
                })
        }
    }
}    
</script>

